import {
  Box,
  Flex,
  HStack,
  IconButton,
  Button,
  useDisclosure,
  useColorModeValue,
  Stack,
  useColorMode,
} from '@chakra-ui/react';
import {Link as ChakraLink} from "@chakra-ui/react"
import { Link } from 'react-scroll';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';
import Resume from "../assets/fw19_0359-Avinash-Kumar-Resume.pdf";

const Links = ['Home', 'About', 'Skills','Projects','Contact'];


export default function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <>
      <Box bg={useColorModeValue('gray.100', 'gray.900')} px={4} position={'fixed'} top={0} overFlow={'hidden'} w='100%' 
      zIndex={"999"} >
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={'center'}>
            <HStack
              as={'nav'}
              spacing={4}
              display={{ base: 'none', md: 'flex' }}>
              {Links.map((link) => (
                <Button key={link} fontSize={{base:"xl",md:"lg",lg:"2xl"}} fontWeight={'bold'}>{
                link==="About"?<Link to="about" spy={true} offset={-50} smooth={true}>{link}</Link>
                :link==="Skills"?<Link to="skills" spy={true} offset={-50} smooth={true}>{link}</Link>
                :link==="Projects"?<Link to="projects" spy={true} offset={-80} smooth={true}>{link}</Link>
                :link==="Contact"?<Link to="contact" spy={true} offset={-50} smooth={true}>{link}</Link>
                :<Link activeClass="active" to="navbar" spy={true} offset={-50} smooth={true}>{link}</Link>
                }
                </Button>
              ))}
              
            </HStack>
          </HStack>
          <Flex alignItems={'center'} gap={{base:"5",md:"0",lg:"10px"}}>
          <ChakraLink href={Resume} download style={{textDecoration: "none"}}>
              <Button
                rounded={'full'}
                fontSize={{base:"xl",md:"lg",lg:"2xl"}}
                fontWeight={'bold'}
                px={6}
                colorScheme={'red'}
                color={'white'}
                bg={'teal'}
                _hover={{ bg: 'teal.300' }}
                onClick={()=>{
                  window.open(Resume)
                }}
                >
                Download Resume
              </Button>
              </ChakraLink>
          <Button onClick={toggleColorMode}>
                {colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
              </Button>
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: 'none' }}>
            <Stack as={'nav'} spacing={4}>
            {Links.map((link) => (
                <Button key={link}>{
                link==="About"?<Link to="about" spy={true} offset={-50} smooth={true} onClick={()=>onClose()}>{link}</Link>
                :link==="Skills"?<Link to="skills" spy={true} offset={-50} smooth={true} onClick={()=>onClose()}>{link}</Link>
                :link==="Projects"?<Link to="projects" spy={true} offset={-80} smooth={true} onClick={()=>onClose()}>{link}</Link>
                :link==="Contact"?<Link to="contact" spy={true} offset={-50} smooth={true} onClick={()=>onClose()}>{link}</Link>
                :<Link activeClass="active" to="navbar" spy={true} offset={-50} smooth={true} onClick={()=>onClose()}>{link}</Link>
                }
                </Button>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
}